export default __webpack_public_path__ + "static/media/link.e4e2d7ac.svg";